import React, { useState, useEffect, useMemo } from "react";
import {
  filterData,
  stateOptions,
  LocationFilterProps,
} from "../../../Data/courseFilterData";

export default function LocationFilter(props: LocationFilterProps) {
  const {
    selectedCountry,
    setSelectedCountry,
    selectedState,
    setSelectedState,
    selectedInstitution,
    setSelectedInstitution,
    selectedEnvironment,
    setSelectedEnvironment,
    selectedPublicTransport,
    setSelectedPublicTransport,
    selectedOverseasTransfer,
    setSelectedOverseasTransfer,
    universityOptions,
    countryOptions,
    stateOptions,
    overseasTransferOptions,
  } = props;

  // State options are now filtered by selected country in Filter.tsx

  return (
    <form
      action=""
      className="grid grid-cols-1 lg:grid-cols-3 gap-2 md:gap-4 text-sm mx-6 lg:mx-0 lg:w-3/4"
    >
      <div className="flex flex-col gap-2 border-2 border-gray-200 rounded shadow-md p-2">
        <label htmlFor="country">{filterData.location.country.label}</label>
        <select
          name="country"
          id="country"
          value={selectedCountry}
          onChange={(e) => {
            setSelectedCountry(e.target.value);
            setSelectedState("");
          }}
        >
          {countryOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div
        className={`flex flex-col gap-2 border-2 border-gray-200 rounded shadow-md p-2
          ${!selectedCountry ? "bg-gray-200 cursor-not-allowed" : ""}
        `}
      >
        <label htmlFor="state">{filterData.location.state.label}</label>
        <select
          name="state"
          id="state"
          value={selectedState}
          onChange={(e) => setSelectedState(e.target.value)}
          disabled={!selectedCountry}
        >
          {stateOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="flex flex-col gap-2 border-2 border-gray-200 rounded shadow-md p-2">
        <label htmlFor="institution">
          {filterData.location.institution.label}
        </label>
        <select
          name="institution"
          id="institution"
          value={selectedInstitution}
          onChange={(e) => setSelectedInstitution(e.target.value)}
        >
          {universityOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {/* <div className="flex flex-col gap-2 border-2 border-gray-200 rounded shadow-md p-2">
        <label htmlFor="environment">
          {filterData.location.environment.label}
        </label>
        <select
          name="environment"
          id="environment"
          value={selectedEnvironment}
          onChange={(e) => setSelectedEnvironment(e.target.value)}
        >
          {filterData.location.environment.options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="flex flex-col gap-2 border-2 border-gray-200 rounded shadow-md p-2">
        <label htmlFor="publicTransport">
          {filterData.location.publicTransport.label}
        </label>
        <select
          name="publicTransport"
          id="publicTransport"
          value={selectedPublicTransport}
          onChange={(e) => setSelectedPublicTransport(e.target.value)}
        >
          {filterData.location.publicTransport.options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div> */}

      <div className="flex flex-col gap-2 border-2 border-gray-200 rounded shadow-md p-2">
        <label htmlFor="overseasTransfer">
          {filterData.location.overseasTransfer.label}
        </label>
        <select
          name="overseasTransfer"
          id="overseasTransfer"
          value={selectedOverseasTransfer}
          onChange={(e) => setSelectedOverseasTransfer(e.target.value)}
        >
          {overseasTransferOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </form>
  );
}
